import React from 'react';

import {NoResultsRow} from 'src/components/no-results-row/no-results-row';
import {COLUMN_CAPTIONS, ColumnTypes} from 'src/modules/admin/ai-assist-usage/constants';
import {DetailedMessage} from 'src/modules/admin/ai-assist-usage/views/detailed-message';
import {UserFeedback} from 'src/openapi/models/UserFeedback';

import {Group, Item} from '@pb/kit-component-group';
import {Loading, Types} from '@pb/kit-component-loading';
import {Rating} from '@pb/kit-component-rating';
import Table, {Body, Cell, Head, Row} from '@pb/kit-component-table';

type Props = {
    userFeedbacks: UserFeedback[],
    isLoading: boolean,
};

const NO_RESULTS_MESSAGE = 'No results found';
const FIRST_ROW = 1;

export const FeedbackTable = ({userFeedbacks, isLoading}: Props) => {
    return (
        <Group direction="v" className="pdx-xxl" gap="xs">
            <Item><strong>User Feedback</strong></Item>
            {isLoading ? <Loading fast={true} type={Types.ICON}/> : (
                <Table>
                    <Head>
                        <Cell/>
                        <Cell>{COLUMN_CAPTIONS[ColumnTypes.COMMENT]}</Cell>
                        <Cell>{COLUMN_CAPTIONS[ColumnTypes.SATISFACTION]}</Cell>
                    </Head>
                    <Body>
                        {userFeedbacks.length ? (
                            userFeedbacks.map((row, index) => (
                                <Row key={index} showCustomZebra={false}>
                                    <Cell>{FIRST_ROW + index}</Cell>
                                    <Cell verticalAlign="middle">
                                        <DetailedMessage caption="Comment" text={row.comment}/>
                                    </Cell>
                                    <Cell><Rating grade={row.rating} readonly={true}/></Cell>
                                </Row>
                            ))
                        ) : <NoResultsRow colSpan={7} message={NO_RESULTS_MESSAGE}/>}
                    </Body>
                </Table>
            )}
        </Group>
    );
};
